export const TOGGLELAYOUT = "TOGGLELAYOUT"
